import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import Copyright from './Copyright';
import styles from './Footer.module.css';
import FooterCountry from './FooterCountry';
import FooterLang from './FooterLang';
import FooterLogo from './FooterLogo';
import FooterNav from './FooterNav';
import License from './License';
import Partners from './Partners';
import SocialLinks from './SocialLinks';

const Footer = ({ data = {}, ...props }) => {
    const promoDarkPage = props.renderOptions?.promoDarkPage || props.renderOptions?.promoDarkFooter || false;
    const containerClass = clsx(styles.footerContainer, {
        [styles.footerContainerBlack]: promoDarkPage,
    });

    const renderFooter = () => {
        if (props.renderOptions?.isLibre) {
            return (
                <>
                    <FooterLogo lang={props.lang} country={props.country} />
                    <SocialLinks links={data.socialLinks} />
                    <Copyright copyright={data.copyright} />
                    <License licence={data?.licence} bank={props.c3p0 ? data.license_bank_3_0 : data.license_bank_2_0} />
                    <Partners />
                </>
            );
        } else {
            const isShowSocialLinks = !props.renderOptions?.isBusinessConnect && !props.renderOptions?.isHR;
            const hideFooterCountryLang = props.renderOptions?.hideFooterCountryLang;

            return (
                <>
                    <FooterNav links={data.links} lang={props.lang} country={props.country} isLanding={props.isLanding} promoDarkPage={promoDarkPage} />
                    <FooterNav links={data.legalLinks} lang={props.lang} country={props.country} isLanding={props.isLanding} promoDarkPage={promoDarkPage} />
                    {!hideFooterCountryLang && (
                        <div className={styles.footerRow}>
                            <FooterCountry
                                countryCode={data.countryCode}
                                countryName={data.countryName}
                                country={props.country}
                                promoDarkPage={promoDarkPage}
                            />
                            <FooterLang isLanding={props.isLanding} isRequest={props.isRequest} promoDarkPage={promoDarkPage} />
                        </div>
                    )}
                    <FooterLogo lang={props.lang} country={props.country} promoDarkPage={promoDarkPage} />
                    {isShowSocialLinks && <SocialLinks links={data.socialLinks} />}
                    <Copyright copyright={data.copyright} promoDarkPage={promoDarkPage} />
                    {!props.renderOptions?.isHR && (
                        <>
                            <License licence={data?.licence} promoDarkPage={promoDarkPage} bank={props.c3p0 ? data.license_bank_3_0 : data.license_bank_2_0} />
                            <Partners promoDarkPage={promoDarkPage} />
                        </>
                    )}
                </>
            );
        }
    };

    return (
        <div className={containerClass}>
            <div className={styles.footerInner}>{renderFooter()}</div>
        </div>
    );
};

Footer.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    isLanding: PropTypes.bool.isRequired,
    data: PropTypes.shape({
        links: PropTypes.array.isRequired,
        legalLinks: PropTypes.array,
        socialLinks: PropTypes.arrayOf(
            PropTypes.shape({
                isBlank: PropTypes.bool,
                name: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            }),
        ),
        copyright: PropTypes.string.isRequired,
        licence: PropTypes.string,
        countryCode: PropTypes.string.isRequired,
        countryName: PropTypes.string.isRequired,
        license_bank_2_0: PropTypes.string,
        license_bank_3_0: PropTypes.string,
    }).isRequired,
    promoDarkPage: PropTypes.bool,
};
export default Footer;
